import {client} from "../axios/client";
import {types} from "../types/types";

export const getInitSteps = (id_customer, token, offset = 0, limit = 10) => {
    return (dispatch) => {
        client.get(`/botactions/${id_customer}/steps`, {
            params: { offset, limit, type: 'init', flow_name: true },
            headers: {'Authorization': `Bearer ${token}`},
        }).then(({data}) => {
            dispatch(initSteps(data));
        });
    };
};

export const initSteps = (init_steps) => ({
    type: types.botInitSteps,
    payload: init_steps,
});

export const getFlowSteps = (id_customer, flow_name, token) => {
    return (dispatch) => {
        client.get(`/botactions/${id_customer}/steps_flow_name`, {
            params: { flow: flow_name },
            headers: {'Authorization': `Bearer ${token}`},
        }).then(({data}) => {
            dispatch(flowSteps(data));
        });
    };
};

export const flowSteps = (flow_steps) => ({
    type: types.botFlowSteps,
    payload: flow_steps,
});

export const getBotSteps = (id_customer, token) => {
    return (dispatch) => {
        client.get(`/steps/`, {
            params: { id_customer, page: 1, page_size: 50 },
            headers: {'Authorization': `Bearer ${token}`},
        }).then(({data}) => {
            dispatch(setBotSteps(data.items || data || []));
        }).catch(() => {
            dispatch(setBotSteps([]));
        });
    };
};

export const setBotSteps = (steps) => ({
    type: types.botSteps,
    payload: steps,
});

export const adBotFlow = (data, token) => {
    return async (dispatch) => {
        return client
            .post(`/amplead/ad-bot-flow`, data, {
                headers: {Authorization: `Bearer ${token}`},
            })
            .then((response) => {
                console.log("adBotFlow", response.data);
                return response.data; // Retornamos la data
            })
            .catch((error) => {
                console.error(error);
                throw error;
            });
    };
};
